"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backInDown = void 0;
const gsap_1 = require("gsap");
const backInDown = (targets) => {
    return gsap_1.gsap
        .timeline({ defaults: { ease: gsap_1.Elastic.easeOut.config(1, 0.3) } })
        .fromTo(targets, {
        duration: 0,
        scale: 0.7,
        opacity: 0,
        translate: '0px -1200px 0px',
        transformOrigin: 'center center',
    }, {
        duration: 0.1,
        scale: 0.7,
        opacity: 1,
        translate: '0px -100px 0px',
    })
        .to(targets, {
        duration: 0.4,
        scale: 0.7,
        translate: '0px 0px 0px',
    })
        .to(targets, {
        duration: 0.5,
        scale: 1,
        translate: '0px 0px 0px',
        stagger: { amount: 0.5 },
    });
};
exports.backInDown = backInDown;
//# sourceMappingURL=back-in-down.js.map